import { useMemo } from 'react';
import { useBounds } from '../useBounds';
import { getViewportTypeFromWidth } from '../useBounds/getViewport';
export const useViewport = ()=>{
    const { width } = useBounds();
    return useMemo(()=>{
        if (width === 0) {
            return {
                isSmallViewport: true,
                isMediumViewport: false,
                isLargeViewport: false,
                isStable: false
            };
        }
        const viewportType = getViewportTypeFromWidth(width);
        return {
            isSmallViewport: viewportType === 'small',
            isMediumViewport: viewportType === 'medium',
            isLargeViewport: viewportType === 'large',
            isStable: true
        };
    }, [
        width
    ]);
};

//# sourceMappingURL=useViewport.js.map